<template>
<div>
  <breadcrumb :items="[{ text: 'Ofertas', to: '/ofertas' }, { text: offer ? offer.name : 'Cadastrar oferta', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <div v-if="product_variation">
      <div class="row mb-5">
        <div class="col-sm-2">
          <product-image :product="product_variation" :product_variation="product_variation" />
        </div>
        <div class="col-sm-10">
          <h4>{{product_variation.name}}</h4>
          <small>{{product_variation.description}}</small>
          <tags :tags="product_variation.tags" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Origem do envio *" description="Lugar onde o produto está estocado aguardando para envio">
            <p v-if="form.address">{{form.address.description}}</p>
            <location :cb="setAddress" :current_address="form.address" :autoload="false" />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Data de fabricação *">
            <b-form-input v-model="form.manufacturing_date" type="date" v-validate="'required'" name="manufacturing_date" />
            <field-error :msg="veeErrors" field="manufacturing_date" />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Redes que englobam esta organização *" v-if="isAdmin">
            <form-entity-select type="organizations" :form="form" field="organization" />
            <field-error :msg="veeErrors" field="organization" />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Quantidade disponível *">
            <b-form-input v-model="form.qtd" type="number" v-validate="'required'" name="qtd" :min="form.qtd_ordered" />
            <small v-if="isEditing() && form.qtd_ordered > 0">Já vendidos: {{form.qtd_ordered}}</small>
            <field-error :msg="veeErrors" field="qtd" />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Emissor da nota fiscal *">
            <b-form-select class="form-control" v-model="form.invoice_issuer" :options="emissores_da_nota" v-validate="'required'" name="invoice_issuer" />
            <field-error :msg="veeErrors" field="invoice_issuer" />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Botão de compra visível?">
            <b-form-checkbox v-model="form.show_buy_button" />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <br>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Preço de fábrica *" class="bmd-form-group final_price">
                <money v-model="form.supplier_price" class="form-control" v-validate="'required'" name="supplier_price" @input="calcFinalPrice"></money>
                <field-error :msg="veeErrors" field="supplier_price" />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Frete/entrega">
                <money v-model="form.shipping_price" class="form-control" @input="calcFinalPrice"></money>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Margem da plataforma">
                <money v-if="isManager" v-model="form.platform_percentage" class="form-control" @input="calcFinalPrice" v-bind="{prefix: '', suffix: ' %'}"></money>
                <span v-else>{{form.platform_percentage}}%</span>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Preço final *" description="Preço de fábrica + frete + margem da plataforma" class="bmd-form-group final_price">
                <money v-model="form.final_price" class="form-control" v-validate="'required'" name="final_price"></money>
                <field-error :msg="veeErrors" field="final_price" />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <form-submit :errors="error" :sending="isSending" :label="isEditing() ? 'Salvar oferta' : 'Publicar oferta'" />
    </div>
    <div v-else>
      <h3>Selecione o produto</h3>
      <form-entity-select type="product_variations" :input="loadProductVariation" label="Selecione o produto" :form="form" field="product_variation" />
    </div>
  </b-form>
</div>
</template>
<script>
import axios from 'axios'
import FormSubmit from '@/components/FormSubmit'
import ProductImage from '@/components/ProductImage';
import FormEntitySelect from '@/components/FormEntitySelect';
import Tags from '@/components/Tags';
import FieldError from '@/components/FieldError'
import Location from '@/components/Location'
import emissores_da_nota from '@/data/emissores-da-nota.json';

export default {

  name: 'OfferForm',
  data() {
    return {
      emissores_da_nota: emissores_da_nota,
      form: {
        product_variation: null,
        manufacturing_date: '',
        supplier_price: 0,
        taxes: 0,
        shipping_to_warehouse_price: 0,
        storage_percentage: 0,
        seller_percentage: 0,
        shipping_percentage: 0,
        platform_percentage: 6,
        final_price: 0,
        lot: '',
        address: null,
        qtd: '',
        qtd_ordered: 0,
        invoice_issuer: '',
        show_buy_button: true,
        organization: null
      },
      product_variation: null,
      offer: null,
    }
  },
  created() {

    if (this.isEditing()) {
      this.edit(this.$route.params.id)
    } else if (this.$route.query.product_variation) {
      axios.get('product_variations/' + this.$route.query.product_variation, {
        params: {
          populate: 'product supplier organization'
        }
      }).then(response => {
        this.setProductVariation(response.data)
      }).catch(this.showError);
    }

  },
  methods: {
    edit(id) {
      this.isLoading = true
      axios.get('offers/' + id, {
        params: {
          populate: 'product_variation product_variation.product'
        }
      }).then(response => {
        this.offer = response.data
        this.apiDataToForm(this.form, this.offer)
        this.setProductVariation(this.offer.product_variation)
        this.isLoading = false
      }).catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          axios({
            method: (this.isEditing() ? 'PUT' : 'POST'),
            url: (this.isEditing() ? 'offers/' + this.offer._id : 'offers'),
            data: this.form
          }).then(resp => {
            var offer = resp.data
            if (offer && offer._id) {
              this.notify("Oferta publicada com sucesso!")
              window.scrollTo(0, 0);
              this.$router.replace('/ofertas')
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    calcFinalPrice() {
      var final_price = this.form.supplier_price + this.form.taxes + this.form.shipping_to_warehouse_price
      if (this.form.storage_percentage && this.form.storage_percentage > 0) {
        final_price += (this.form.supplier_price * this.form.storage_percentage) / 100
      }
      if (this.form.seller_percentage && this.form.seller_percentage > 0) {
        final_price += (this.form.supplier_price * this.form.seller_percentage) / 100
      }
      if (this.form.shipping_percentage && this.form.shipping_percentage > 0) {
        final_price += (this.form.supplier_price * this.form.shipping_percentage) / 100
      }
      if (this.form.shipping_price && this.form.shipping_price > 0) {
        final_price += this.form.shipping_price
      }

      if (this.form.platform_percentage && this.form.platform_percentage > 0) {
        final_price = (final_price * 100) / (100 - this.form.platform_percentage)
      }

      this.form.final_price = final_price
    },
    setProductVariation(product_variation) {
      this.form.product_variation = product_variation._id
      if (!this.form.final_price) {
        this.form.supplier_price = product_variation.final_price
      }
      this.calcFinalPrice()
      this.product_variation = product_variation
      if (!this.isEditing()) {
        if (this.product_variation.supplier && this.product_variation.supplier.issue_invoice) {
          this.form.invoice_issuer = 'supplier'
        } else if (this.product_variation.organization && this.product_variation.organization.issue_invoice) {
          this.form.invoice_issuer = 'organization'
        } else {
          this.form.invoice_issuer = 'platform'
        }
      }
    },
    loadProductVariation(product_variation) {
      axios.get('product_variations/' + product_variation.id, {
        params: {
          populate: 'product supplier organization'
        }
      }).then(response => {
        this.setProductVariation(response.data)
      }).catch(this.showError);
    },
    setAddress(address) {
      this.form.address = address
    }

  },
  components: {
    FormSubmit,
    ProductImage,
    FormEntitySelect,
    Tags,
    FieldError,
    Location
  }
};
</script>
<style lang="sass" scoped>
  .thumb
    max-width: 100%
    max-height: 100%
  .final_price
    font-size: 14px
    font-weight: bold
    input
      font-size: 18px
</style>
